import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('stock-barang/index', {params});
    },
    getItem(params) {
        return Service().get('stock-barang/get-item', {params});
    },
    show(id) {
        return Service().get('stock-barang/show/'+id);
    },
    create(params) {
        return Service().post('stock-barang/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('stock-barang/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('stock-barang/delete/'+id);
    },
    getStockCard(params) {
        return Service().get('stock-barang/get-stock-card', {params});
    },
    cutOff(params) {
        return Service().post('stock-barang/cut-off', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}